// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__exqP_","content":"Button_content__odjnK","spinner":"Button_spinner__XcCkv","spin":"Button_spin__ITV3l"};